var _g, _path, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnBreezeaio = function SvgIcnBreezeaio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.981 12.973c-.012-.012-.825-.786-4.212-1.362 0 0-1.85-.337-3.708-.414-1.858-.078-3.487-.376-4.767-1C2.014 9.57.114 7.834 0 5.577c.01.014.87 1.18 2.905 2.345C4.952 9.095 6.494 9.16 8.05 9.15c1.013-.007 2.055.012 3.339.479h.001c.79.296 1.538.683 2.232 1.152l.071.047c.867.577 1.672 1.289 2.287 2.145Z",
    fill: "url(#icn_breezeaio_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M15.981 12.95v.024c-.614-.857-1.419-1.568-2.285-2.144a4.877 4.877 0 0 0-.072-.047c-.83-.545-1.563-.91-2.231-1.153h-.002c-1.285-.467-2.326-.486-3.34-.479-1.555.011-3.099-.055-5.146-1.227C.87 6.759.012 5.594 0 5.58c.014.011.915.75 3.763 1.249.641.113 1.247.183 1.818.227 1.981.154 3.524-.005 4.583.206 1.364.273 2.434.856 3.537 2.013 1.103 1.158 1.98 2.712 2.28 3.675Z",
    fill: "url(#icn_breezeaio_svg__b)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.981 12.95v.024c-.614-.857-1.419-1.568-2.285-2.144a4.86 4.86 0 0 0-.072-.047c-.83-.545-1.563-.91-2.231-1.153h-.002a13.324 13.324 0 0 0-.831-.301c-1.554-.506-3.443-1.085-4.978-2.273a7.546 7.546 0 0 1-.726-.638C3.226 4.784 3.535 3 3.535 3s3.242.464 6.356 1.434c3.113.97 4.743 2.804 5.463 4.919.667 1.959.636 3.395.627 3.595Z",
    fill: "url(#icn_breezeaio_svg__c)",
    opacity: 0.71
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.981 12.95v.024c-.614-.857-1.42-1.569-2.286-2.144l-.071-.047c-.83-.545-1.563-.91-2.232-1.153h-.001a13.242 13.242 0 0 0-.832-.302c-1.553-.505-3.442-1.084-4.977-2.272 1.98.154 3.524-.005 4.583.206 1.364.274 2.434.856 3.537 2.014 1.103 1.157 1.98 2.71 2.28 3.673Z",
    fill: "url(#icn_breezeaio_svg__d)",
    opacity: 0.71
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icn_breezeaio_svg__a",
    x1: 0,
    y1: 9.276,
    x2: 15.98,
    y2: 9.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#787BFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#5032E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icn_breezeaio_svg__b",
    x1: 0,
    y1: 9.277,
    x2: 15.982,
    y2: 9.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#635FF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icn_breezeaio_svg__c",
    x1: 3.511,
    y1: 7.987,
    x2: 15.985,
    y2: 7.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5BBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B59C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icn_breezeaio_svg__d",
    x1: 5.581,
    y1: 10.015,
    x2: 15.981,
    y2: 10.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#827EF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C57EF"
  })))));
};
export default SvgIcnBreezeaio;